/* eslint-disable no-template-curly-in-string */
/* eslint-disable import/prefer-default-export */
export const topicTreeIntentsFPTIs = {
  topicTreeIntentsSuccess: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:topic-intents',
    e: 'ac',
    link: 'contact-us|topic-intents|${intents}',
    event_name: 'contact_us_topic_intents_shown',
  },
  topicTreeIntentsError: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:topic-intents',
    e: 'ac',
    event_name: 'contact_us_topic_intents_error',
  },
  topicTreePriorityIntentClick: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:topic-intents',
    e: 'cl',
    link: 'contact-us|topic-intents|priority-intent|click|${intentCode}',
    event_name: 'contact_us_topic_intents_priority_intent_clicked',
  },
  topicTreeFinalIntentChangeRequested: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:topic-intents',
    e: 'cl',
    link: 'contact-us|topic-intents|final-intent|change',
    event_name: 'contact_us_topic_intents_final_intent_changed',
  },
  topicTreeSuggestedIntentClick: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:topic-intents',
    e: 'cl',
    link: 'contact-us|topic-intents|suggested-intent|click|${intentCode}',
    event_name: 'contact_us_topic_intents_suggested_intent_clicked',
  },
  topicTreeSearchOptionClick: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:topic-intents',
    e: 'cl',
    link: 'contact-us|topic-intents|search-option|click',
    event_name: 'contact_us_topic_intents_search_option_clicked',
  },
  topicTreePriorityIntentSearchSheetOpen: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:topic-intents',
    e: 'ac',
    link: 'contact-us|topic-intents|search-sheet|open',
    event_name: 'contact_us_topic_intents_search_sheet_shown',
  },
  topicTreeSearchBarClick: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:topic-intents',
    e: 'cl',
    link: 'contact-us|topic-intents|search-sheet|search-bar|click',
    event_name: 'contact_us_topic_intents_search_sheet_search_bar_clicked',
  },
  topicTreePriorityIntentSearchSheetClose: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:topic-intents',
    e: 'cl',
    link: 'contact-us|topic-intents|search-sheet|close',
    event_name: 'contact_us_topic_intents_search_sheet_close',
  },
  topicTreeSearchSheetAutoSuggestShown: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:topic-intents',
    e: 'ac',
    link: 'contact-us|topic-intents|search-sheet|auto-suggest|shown',
    event_name: 'contact_us_topic_intents_search_sheet_auto_suggest_shown',
  },
};

// OCP Prompt FPTIs
export const ocpPromptFPTIs = {
  ocpPromptShown: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:omni-channel-prompt',
    e: 'ac',
    event_name: 'contact_us_ocp_prompt_shown',
  },
  ocpPromptClicked: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:omni-channel-prompt',
    e: 'cl',
    link: 'contact-us|ocp-prompt|click|${ocpIntent}',
    event_name: 'contact_us_ocp_prompt_clicked',
  },
  ocpPromptOverflowClicked: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:omni-channel-prompt',
    e: 'cl',
    link: 'contact-us|ocp-prompt|click|something-else-option',
    event_name: 'contact_us_ocp_prompt_something_else_option_clicked',
  },
  ocpPromptChangeBtnShown: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:omni-channel-prompt',
    e: 'ac',
    event_name: 'contact_us_ocp_prompt_change_button_shown',
  },
  ocpPromptChangeRequested: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:omni-channel-prompt',
    e: 'cl',
    link: 'contact-us|ocp-prompt|change-button|${ocpIntent}',
    event_name: 'contact_us_ocp_prompt_change_button_clicked',
  },
  ocpPromptArticleLinkShown: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:omni-channel-prompt',
    e: 'ac',
    event_name: 'contact_us_ocp_prompt_article_link_shown',
  },
  ocpPromptArticleLinkClicked: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:omni-channel-prompt',
    e: 'cl',
    link: 'contact-us|ocp-prompt|click|ocp-article-link|${articleId}',
    event_name: 'contact_us_ocp_prompt_article_link_clicked',
  },
};

export const contactOptionsFPTIs = {
  contactOptionsShown: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:${type}-contact-options',
    e: 'ac',
    link: 'contact-us|contact-options|${parsedChannels}|${type}|${intentCode}',
    event_name: 'contact_us_${type}_contact_options_shown',
  },
  contactOptionsError: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:contact-options',
    e: 'ac',
    event_name: 'contact_us_contact_options_error',
  },
  contactOptionClick: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:contact-options',
    e: 'cl',
    link: 'contact-us|contact-option|click|${channelName}',
    event_name: 'contact_us_contact_option_${channelName}_clicked',
  },
};

export const contactUsFPTIs = {
  contactUsPageLoading: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:contact-us',
    e: 'im',
    link: 'contact-us|contact-us-page|shown',
    event_name: 'contact_us_page_shown',
  },
};

export const chatBotFPTIs = {
  chatBotPromptContactUsShown: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:chat-bot',
    e: 'ac',
    link: 'contact-us|chat-bot|prompt|${topicRefId}',
    event_name: 'contact_us_chat_bot_prompt_shown',
  },
  chatBotMessageBtnContactUsShown: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:chat-bot',
    e: 'ac',
    link: 'contact-us|chat-bot|button|${topicRefId}',
    event_name: 'contact_us_chat_bot_button_shown',
  },
  chatBotPromptContactUsClose: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:chat-bot',
    e: 'cl',
    link: 'contact-us|chat-bot|prompt|${topicRefId}|close|clicked',
    event_name: 'contact_us_chat_bot_prompt_close',
  },
  chatBotContactUsClick: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:chat-bot',
    e: 'cl',
    link: 'contact-us|chat-bot|chat-bot|${topicRefId}|clicked',
    event_name: 'contact_us_chat_bot_click',
  },
};

export const heroFPTIs = {
  heroBackButtonShown: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:hero',
    e: 'ac',
    link: 'contact-us|hero|${btnType}',
    event_name: 'contact_us_hero_back_${btnType}_button_shown',
  },
  heroBackButtonClick: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:hero',
    e: 'cl',
    link: 'contact-us|hero|${btnType}|clicked',
    event_name: 'contact_us_hero_back_${btnType}_button_clicked',
  },
};

export const callUsFPTIs = {
  callUsPageShown: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:call-us',
    e: 'ac',
    link: 'contact-us|call-us|${topicRefId}',
    event_name: 'contact_us_call_us_shown',
  },
  callUsLoginBtnClick: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:call-us',
    e: 'cl',
    link: 'contact-us|call-us|login-btn|clicked',
    event_name: 'contact_us_call_us_login_btn_clicked',
  },
  callUsPhoneNumberClick: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:call-us',
    e: 'cl',
    link: 'contact-us|call-us|phone-no|${phoneNo}|clicked',
    event_name: 'contact_us_call_us_phone_number_clicked',
  },
  callUsPhoneNumber: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:call-us',
    e: 'cl',
    link: 'contact-us|call-us|phone-no|${phoneNo}',
    event_name: 'contact_us_call_us_phone_number_shown',
  },
  callUsWebPinShown: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:call-us',
    e: 'cl',
    link: 'contact-us|call-us|web-pin|${webPinNo}',
    event_name: 'contact_us_call_us_web_pin_shown',
  },
  callUsWebPinStepUpAuth: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:call-us',
    e: 'ac',
    link: 'contact-us|call-us|web-pin-ste-up-auth|${phoneNo}|',
    event_name: 'contact_us_call_us_web_pin_shown',
  },
};
